import { FC } from 'react'
import { useTheme } from 'styled-components'

import { FormFieldInputProps } from '../FormFieldInput'

import * as SC from './styled'

export type FormFieldDateProps = Omit<FormFieldInputProps, 'type'> & {
  type: 'datetime-local' | 'date'
}

const FormFieldDate: FC<FormFieldDateProps> = ({
  className,
  type = 'date',
  ...props
}) => {
  const theme = useTheme()
  return (
    <SC.Input
      className={className}
      type={type}
      leftAdornment={
        <SC.Calendar
          icon="schedule"
          width={20}
          height={20}
          color={theme.colors.greyContour}
        />
      }
      {...props}
    />
  )
}

export default FormFieldDate
